import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const LeftPanelSection = ({ icon, title, heading, links = [], replace }) => (
  <div className="nav-leftpanel--ll-item">
    {title && (
      <div className="nav-leftpanel--ll-heading">
        <span className="nav-leftpanel--icon">
          <img src={icon} alt="" />
        </span>
        <span>{title}</span>
      </div>
    )}
    {heading && (
      <div className="nav-leftpanel--ll-link">
        <div><h5>{heading}</h5></div>
      </div>
    )}
    <div className="nav-leftpanel--ll-link">
      {links.map(link => (
        <NavLink
          replace={replace || link.replace}
          key={link.name}
          exact={true}
          to={link.to}
          activeClassName="active"
        >
          {link.name}
        </NavLink>
      ))}
    </div>
  </div>
);

LeftPanelSection.propTypes = {
  replace: PropTypes.bool.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string,
  heading: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};
LeftPanelSection.defaultProps = {
  replace: false,
};
export default LeftPanelSection;



// WEBPACK FOOTER //
// ./src/components/ui/LeftPanelSection.jsx